import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { logUsage } from 'owa-analytics';
import strings from 'owa-strings/owa-mail-strings';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import * as React from 'react';
var styles = require('./ComposeDropHint.scss');
var classNames = require('classnames/bind').bind(styles);
var ComposeDropHint = /** @class */ (function (_super) {
    tslib_1.__extends(ComposeDropHint, _super);
    function ComposeDropHint() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComposeDropHint.prototype.componentDidMount = function () {
        this.logPrimaryViewDataTransferDatapoints();
    };
    ComposeDropHint.prototype.componentDidUpdate = function () {
        this.logPrimaryViewDataTransferDatapoints();
    };
    ComposeDropHint.prototype.render = function () {
        var _a = this.props, dataTransferType = _a.dataTransferType, dropViewState = _a.dropViewState, dockingPlugin = _a.dockingPlugin;
        var label;
        switch (dataTransferType) {
            case DraggableItemTypes.MailListRow:
                label = strings.dropHintMessagesLabel;
                break;
            case DraggableItemTypes.LocalFile:
                label = strings.dropHintFilesLabel;
                break;
            case DraggableItemTypes.Attachment:
                label = strings.dropHintFilesLabel;
                break;
            default:
                return null;
        }
        var info = dockingPlugin.getVisibleAreaInfo();
        var outlineWidthInPx = 2;
        var pxString = 'px';
        info.top += outlineWidthInPx;
        info.bottom += outlineWidthInPx;
        var dropHintAreaCSS = {
            top: info.top + pxString,
            bottom: info.bottom + pxString,
            left: outlineWidthInPx + pxString,
            right: outlineWidthInPx + pxString,
            'outline-width': outlineWidthInPx + pxString,
        };
        var dropHintAreaClassNames = classNames(styles.dropHintArea, {
            isDraggingItemsIntoEditor: dropViewState.isDragOver,
            isDraggingItemsIntoPrimaryViewButNotEditor: !dropViewState.isDragOver,
        });
        var shouldDisplayInBigSize = info.visibleBodyHeight >= 200 && info.visibleBodyWidth >= 400;
        return (React.createElement("span", { className: dropHintAreaClassNames, style: dropHintAreaCSS },
            React.createElement(Icon, { className: classNames({ dropHintIconInBigSize: shouldDisplayInBigSize }, { dropHintIconInSmallSize: !shouldDisplayInBigSize }), iconName: "Attach" /* Attach */ }),
            React.createElement("span", { className: classNames({ dropHintLabelInBigSize: shouldDisplayInBigSize }, { dropHintLabelInSmallSize: !shouldDisplayInBigSize }) }, label)));
    };
    ComposeDropHint.prototype.logPrimaryViewDataTransferDatapoints = function () {
        var _a = datapoints.ComposeDropHint.datapoint, eventName = _a.name, customData = _a.customData;
        logUsage(eventName, customData(this.props.dataTransferType));
    };
    ComposeDropHint = tslib_1.__decorate([
        observer
    ], ComposeDropHint);
    return ComposeDropHint;
}(React.Component));
export default ComposeDropHint;
//# sourceMappingURL=ComposeDropHint.js.map